import { useState, useCallback, useRef } from "react";

export function useUndoRedo(initialState) {
  const undoStack = useRef([]);
  const [value, setValue] = useState(initialState);
  const pointerRef = useRef(0);

  // Memoized deep clone function
  const deepClone = useCallback(obj => JSON.parse(JSON.stringify(obj)), []);

  const canUndo = pointerRef.current > 0;
  const canRedo = pointerRef.current < undoStack.current.length - 1;

  const updateState = useCallback(
    (newState, options = {}) => {
      const { trackInUndo = true, ignoreUpdate = false } = options;

      if (ignoreUpdate) return;

      // Skip adding to history if currency is empty
      const skipHistory = newState.currency === "";

      if (skipHistory) {
        return;
      }

      // Create a deep clone of the current value for the undo stack
      const valueToStore = deepClone(value.currency === "" ? newState : value);

      // If trackInUndo is FALSE, update the last undo entry (if exists)
      if (!trackInUndo && undoStack.current.length > 1) {
        undoStack.current[undoStack.current.length - 1] = deepClone(newState);
      }
      // Otherwise (trackInUndo is TRUE), push a new undo entry
      else if (trackInUndo) {
        if (pointerRef.current < undoStack.current.length - 1) {
          undoStack.current.splice(pointerRef.current + 1);
        }

        undoStack.current.push(deepClone(valueToStore));
        pointerRef.current = undoStack.current.length - 1;
        // pointerRef.current = undoStack.current.length;
        // undoStack.current.push(deepClone(valueToStore));
      }

      // Update the current value
      setValue(newState);
    },
    [value, deepClone]
  );

  const undo = useCallback(() => {
    // if (undoStack.current.length === 0 || pointerRef.current <= 0) return;
    if (!canUndo) return;

    // Set to the previous state
    pointerRef.current--;
    setValue(deepClone(undoStack.current[pointerRef.current]));
  }, [canUndo, deepClone]);

  const redo = useCallback(() => {
    // if (pointerRef.current >= undoStack.current.length - 1) return;
    if (!canRedo) return;
    pointerRef.current++;
    setValue(deepClone(undoStack.current[pointerRef.current]));
  }, [canRedo, deepClone]);

  return {
    state: value,
    updateState,
    undo,
    redo,
    canUndo,
    canRedo,
  };
}
